import { TradeList, GetTradesParams, TradeFilter } from "../types";
import { User } from "../../../auth/types";
import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

const getTradesWebApi = (
  user: User,
  page?: number,
  itemsPerPage?: number,
  filter?: TradeFilter,
) => {
  const params: GetTradesParams = {
    userid: user.userId,
    domfor: "D",
    secid: filter?.security?.securityId,
    numofrows: itemsPerPage,
    fromrow: page && itemsPerPage ? page * itemsPerPage : undefined,
    datefrom: getParamsDateString(filter?.datefrom),
    dateto: getParamsDateString(filter?.dateto),
  };

  return webApiWithResponse<TradeList[]>({
    method: "GET",
    url: "trade/gettranlist",
    params,
  });
};

export default getTradesWebApi;
